/**
 * Device detection utilities for DPR.
 */

export function getDPR(): number {
  if (typeof window === 'undefined') return 1;
  const dpr = window.devicePixelRatio || 1;
  // Round to 1 or 2 for most cases (can be extended to 3 for high-DPI)
  return dpr >= 2 ? 2 : 1;
}

